/** Zero-pads a number to two digits (e.g. 9 → "09"). */
export const padTwo = (n: number): string => String(n).padStart(2, '0');

/**
 * Monday-anchored start of week in UTC. Dates are UTC-naive; UTC math avoids
 * the viewer's browser offset shifting an item into an adjacent bucket.
 */
export const startOfUtcWeek = (date: Date): Date => {
  const d = new Date(
    Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
  );
  const diff = (d.getUTCDay() + 6) % 7;
  d.setUTCDate(d.getUTCDate() - diff);
  return d;
};

/**
 * Converts a local calendar-day picker range to an inclusive UTC instant range: the start
 * of the first day through the last millisecond of the last day, as ISO strings.
 */
export const toUtcDayRange = ([from, to]: [Date | null, Date | null]): {
  fromUtc?: string;
  toUtc?: string;
} => {
  const start = from ? new Date(from) : null;
  start?.setHours(0, 0, 0, 0);
  const end = to ? new Date(to) : null;
  end?.setHours(23, 59, 59, 999);
  return {
    fromUtc: start?.toISOString(),
    toUtc: end?.toISOString(),
  };
};
